import { ReactNode } from 'react'
import SplitControl from '@/components/business/SplitControl'
import NotFound from '@/pages/NotFound'

type Props = {
  children: NonNullable<ReactNode>
}

const SplitHandler = ({ children }: Props) => {
  return (
    <SplitControl splitName="enable_on_sales_page" treatmentOff={<NotFound />}>
      {children}
    </SplitControl>
  )
}

export default SplitHandler
